export default <TArgs, TData>(
  key: string,
  rpcMethod: Parameters<typeof useRpc>[0],
) => {
  const params = ref<any>()
  const { data, refresh, status } = useRpc(rpcMethod, key, params, {
    immediate: false,
    lazy: false,
  })

  const fetch = async (options: TArgs) => {
    params.value = options
    await refresh()
    return data.value as TData
  }

  return {
    data: data as Ref<TData | undefined>,
    status,
    fetch,
  }
}
